import { render, staticRenderFns } from "./ChatSidebarMessageListItem.vue?vue&type=template&id=7bb9514f&scoped=true&"
import script from "./ChatSidebarMessageListItem.vue?vue&type=script&lang=js&"
export * from "./ChatSidebarMessageListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebarMessageListItem.vue?vue&type=style&index=0&id=7bb9514f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9514f",
  null
  
)

export default component.exports